import React from 'react'
import { Row, Col, Select, Form } from 'antd'
import MemoryStore from '../../../../../utils/memory-store'
import GoogleDriveRoute from './google-drive-route'

class GoogleDriveRouteMain extends React.Component {
  constructor(props) {
    super(props)

    this.entry = MemoryStore.activeEntries[this.props.tabKey]

    this.state = {
      entry: props.entry,
      routeType: props.entry.routeData.routeType ? props.entry.routeData.routeType : ''
    }
  }

  onFieldChange(key, value) {
    this.entry.custom.isModifiedSubform = true
    this.props.entry.routeData[key] = value
  }

  render() {
    return (
      <Row>
        <Col xs={24} xl={16}>
          <h3>Route Info</h3>
          <Form.Item>
            <span style={{ color: 'red' }}>* </span>Route Type
            <Select
              className='route_type'
              disabled={MemoryStore.userProfile.teamPrivileges.connectors === 'Reader'}
              defaultValue={this.state.routeType}
              onChange={(e) => {
                this.setState({ routeType: e })
                this.onFieldChange('routeType', e)
              }}
            >
              <Select.Option value=''>-Select-</Select.Option>
              <Select.Option value='0'>List Directory</Select.Option>
              <Select.Option value='1'>Upload File</Select.Option>
              <Select.Option value='2'>Download File</Select.Option>
            </Select>
          </Form.Item>
          <GoogleDriveRoute entry={this.props.entry} routeType={this.state.routeType} />
        </Col>
      </Row>
    )
  }
}

export default GoogleDriveRouteMain
